import React from 'react'
import Layout from '.'
import { Outlet } from 'react-router-dom'


const WithFrontLayout = () => {
  return (
    <Layout>
        <Outlet />
    </Layout>
  )
}

export default WithFrontLayout